import Layout from '@/layout/index.vue';
var gameRouter = {
  path: '/game',
  component: Layout,
  redirect: '/game/list',
  name: 'Game',
  meta: {
    title: '游戏管理'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/game/list/index.vue');
    },
    name: 'GameList',
    meta: {
      title: '游戏列表'
    }
  }, {
    path: 'cate',
    component: function component() {
      return import('@/views/game/cate/index.vue');
    },
    name: 'GameCate',
    meta: {
      title: '游戏分类'
    }
  }, {
    path: 'bet',
    component: function component() {
      return import('@/views/game/bet/index.vue');
    },
    name: 'GameBet',
    meta: {
      title: '游戏打码记录'
    }
  }]
};
export default gameRouter;